import {useState, useEffect} from 'react';

/**
 * Hook to force a component update on a given time interval in ms.
 *
 * @param {number} interval - How often to update
 */
const useUpdateOnInterval = (interval = 500) => {
  const [flag, setFlag] = useState(false);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setFlag(!flag);
    }, interval);
    return () => clearTimeout(timeoutId);
  });
};

export default useUpdateOnInterval;
